module.exports = __webpack_public_path__ + "static/media/typescriptIcon.6268d13f.svg";